import ExaminationEvents from './ExaminationEvents';

export default ExaminationEvents;
